import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from '../../../../models/useDashboardDaysModel';
import { DashboardPeriod } from '../../../../types/dashboard';
import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import { useExpandSection } from '../useExpandSection';
import { ScamBySourceType } from './ScamBySourceType';
import { ScamOverall } from './ScamOverall';
import { ScamTop5 } from './ScamTop5';
import { ScamWidgetId } from './type';

const initData = {
  '24h': {},
  '1w': {},
  '1M': {},
};

const initDataArr = {
  '24h': [],
  '1w': [],
  '1M': [],
};

const Scam = () => {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'scam',
      period: daysModel.days.DashboardScam as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.scam')}
      titleBar={<TimeRangeSelector widgetId="DashboardScam" />}
      barColor="#42B6C62"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <ScamOverall
        data={data || { summaryScam: initData, summaryScamPrevious: initData }}
      />
      <ScamTop5
        data={data || { scamTopEmailSender: initDataArr }}
        type={ScamWidgetId.ScamTopEmailSender}
      />
      <ScamTop5
        data={data || { scamTopRecipient: initDataArr }}
        type={ScamWidgetId.ScamTopRecipient}
      />
      <ScamBySourceType data={data || { scamFilter: initDataArr }} />
    </DashboardLayout>
  );
};

export default Scam;
